/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { PartialAddress, ShippingMethod } from '@/cart/data/models';

export const transformPartialAddress = (data: any): PartialAddress => {
  return {
    countryCode: data.country_code || 'US',
    postCode: data.postcode || '',
    region: data.region?.region || '',
    regionId: data.region?.id,
  };
};

export const transformShippingMethod = (data: any): ShippingMethod | null => {
  if (!data) return null;

  return {
    carrierCode: data.carrier_code || '',
    methodCode: data.method_code || '',
    amount: data.amount,
    ...(data.price_excl_tax && {
      amountExclTax: {
        value: data.price_excl_tax.value,
        currency: data.price_excl_tax.currency,
      },
    }),
    ...(data.price_incl_tax && {
      amountInclTax: {
        value: data.price_incl_tax.value,
        currency: data.price_incl_tax.currency,
      },
    }),
  };
};
